<template>
  <b-modal ref="modal" size="xl" :hide-footer="false">
    <template slot="modal-header" >
      <div>
        Other matches
      </div>
    </template>
    <template >
      <div class="upload">
        <div class="body">
          <template>
             <span> Here you have list of similar tracks that you can choose from as a replacement. These alternatives are carefully curated to</span>
              <span style="padding-bottom: 7px"> ensure they match the title and artist of the original song as closely as possible.</span><br>

            <div v-if="tracks">
              <DataTable :value="tracks" tableStyle="min-width: 50rem" style="margin-top: 30px;">

                <Column field="title" header="Title">
                  <template #body="slotProps">
<!--                    {{slotProps.data}}-->
                    <PlayButton class="play-button mr-2" :track="slotProps.data"></PlayButton>
                    <span v-text="slotProps.data.title"></span>
                  </template>
                </Column>
                <Column field="artist" header="Artist"></Column>
                <Column field="isrc" header="ISRC"></Column>
                <Column field="year" header="Year" style="width: 7%;"></Column>
                <!--              <Column  header="Duration">-->
                <!--                <template #body="slotProps">-->
                <!--                  {{slotProps.duration}}-->
                <!--                  <span v-text="calculDuration(slotProps.duration)">    </span>-->
                <!--                </template>-->
                <!--              </Column>-->
                <Column field="" header="">
                  <template #body="slotProps">
                   <span v-tooltip="{ data:  'Choose this track to replace actual one' , arrowPosition: 'right'}" style="margin-left: 7px">
                      <Button @click="choose(slotProps.data)"  download>
                        <template>{{  'Select' }}</template>
                      </Button>
                   </span>
                  </template>
                </Column>
              </DataTable>
            </div>

          </template>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <Button :empty="empty" style="background: #ffffff; color: #EA8F34" class="close-popup" @click.prevent="$refs.modal.hide()">{{ Translations.buttons.cancel }} </Button>
<!--      <button :empty="empty" class="primary"  :disabled="null" @click.prevent="confirm">Save</button>-->
    </template>

  </b-modal>

</template>

<script>
import Bootstrap from "bootstrap-vue";
import Constants from "@/store/constants";
import Translations from "@/store/translations";
import {mapState} from 'vuex'
import store from "@/store";
import Button from "@/components/common/Button.vue";
import Axios from "axios";
import {HTTP} from "@/utils/http";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import PlayButton from "@/components/common/PlayButton.vue";

export default {
  name: "OtherTracks",
  store,
  components: {PlayButton, Button , DataTable ,Column},
  props: {
      stationUid: { required: true },
      currentTrack: { required: true },
      multiSearchUid: { required: true },
      noModalEdit: null,
      empty: { type: Boolean, required: true, default: false },
  },
  computed: {
    ...mapState(['currentStation' ]),
    Translations: () => Translations,
    Constants: () => Constants,

  },
  data() {

    return {
      uploadData: null,
      tracks:[],
      errorMessage: false,
    };
  },

  mounted() {
     this.loadOthersTracks();
  },
  watch: {
    type: { }
  },

  methods: {
    resetModalState(toggler) {

    },
    choose(track){
      this.$bvModal.msgBoxConfirm('Are you sure you want to replace the selected song with this one?', {
        title: 'Confirmation',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'outline-warning',
        okTitle: 'Ok',
        cancelTitle: 'Cancel',
        cancelVariant: 'light',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
          .then(value => {
                if(value){
        var OtherTracks = [];

        for (let i = 0; i < this.tracks.length; i++) {
          if (this.tracks[i].id !== track.id) {
            console.log(this.tracks[i].id , track.id)
            console.log(track)
            OtherTracks.push(this.tracks[i].id)
          }
        }
        OtherTracks.push(this.currentTrack.id)
                  console.log(OtherTracks)
        HTTP.post('api/multi-search/'+this.multiSearchUid+'/item/'+ this.itemId,
            {
              Id: this.itemId,
              MultiSearchUid: this.multiSearchUid,
              Found: true,
              OtherTracks: OtherTracks.length > 0 ? JSON.stringify(OtherTracks) : null,
              TrackId: track.id
            })
            .then(response => {
              console.log(response)
              if (response.status === 200) {
                this.makeToast('Tracks list updated successfully', 'success', 'Success')
                this.confirm();
              } else {
                this.makeToast('Failed to update the Track list', 'danger', 'Error')
              }
            }).catch(error => {
        })
      }
        })
    .catch(err => {
      // An error occurred
    })

    },
    makeToast(msg , type , title) {
      this.$store.dispatch('Toasts/addToast', {
        title: title,
        message: msg,
        type: type
      });
    },
    loadOthersTracks () {
      console.log(this.itemId , this.multiSearchUid)
      if (this.itemId && this.multiSearchUid){
        HTTP.get('api/multi-search/'+this.multiSearchUid+'/item/'+ this.itemId+'/other-tracks')
       // HTTP.get('api/multi-search/EB1B0C5E-AAD4-4361-8746-BE154646CFA7/item/239/other-tracks')
            .then(({ data }) => {
              this.errorMessage = false;
              this.tracks = data.dataItem

              console.log('----------------------------------------------------------------------------------------------')
              console.log( this.fileList)
            })
            .catch(error => {
              this.errorMessage = true;
              console.log('-------------')
              console.log('error', error)
            })
      }

    },
    show(object) {
      console.log(object)
      this.itemId = object.itemId
      this.currentTrack = object.currentTrack
      this.multiSearchUid = object.multiSearchUid
      this.clean();
      this.loadOthersTracks();
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    confirm() {
      this.$emit("confirmed");
      this.hide();
    },

    clean(){
    },
  },

};
</script>

<style lang="scss" scoped>
.upload {
  width: 480px;
}

header {
  font-size: 26px;
  color: #292c33;
  text-align: center;

  padding: 35px;
}

.body {
  padding: 0 35px 35px 35px;

  h3 {
    color: #696b70;
    font-size: 13px;
  }
}

.count {
  color: #000;
  font-weight: 600;
}

footer {
  border-top: 1px solid #d2d2d2;
  height: 80px;
  padding: 35px;

  a {
    color: #d2d2d2;
    text-transform: uppercase;
    font-size: 13px;
  }

  button {
    text-transform: uppercase;
  }
}
.upload-box{
  li{
    height: auto;
    input{
      &[type=radio]{
        height: 24px;
      }
    }
    label{
      margin: 0;
    }
  }
}
.search-container {
  overflow: hidden;
  height: 100%;
  height:400px;
  display:flex;
  flex-direction:column;
  flex-grow: 1;
  justify-content: stretch;
  align-self: flex-start;
  ul{
    height: 100%;
    overflow: auto;
    input{
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.7px;
      line-height: 1;
    }
    li {
      span{
        font-weight:600;
        font-size:12px
      }
      span.badge {
        font-weight:400;
        font-size:10px
      }
    }
  }
}

.box-source-wrapper {
  position: relative;
  padding-left: 25px;

  i {
    position: absolute;
    left: 0;
    top: 5px;
  }
}

.search-container .search-content {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  flex-shrink: 0;
  height: 100%;
}

.source-column li.header {
  position: sticky;
  top: 0;
  background:#fff;
  z-index:100;
  padding: 10px;
  border-bottom: 1px solid #dee2e6;
  height:41px;
  display:flex;
  align-items: center;
}

#station-source.source-column {
  width: 70%;
  height: 100%;
  overflow: auto;
}

#box-source.source-column {
  width: 50%;
  flex-shrink: 0;
  border-right: 1px solid #dee2e6;
}

.search-container header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding: 10px 15px;
  border-bottom: var(--COLOR_BORDERS) 1px solid;
}

.search-container header h4 {
  margin: 0;
}

.source-column li {
  height: auto;
  padding: 7px 10px;
  align-items: baseline;
}

.source-column li i {
  margin-right: 15px;
}

.source-column li i:hover {
  margin-right: 15px;
  color: var(--COLOR_BRAND);
}



.source-column li .station-label {
  font-size: 12px;
  font-weight: 600;
}

.source-column li i.fa-check {
  opacity: 0.1;
  transition: color 0.2s ease-in-out;
}

.source-column li.active i.fa-check {
  opacity: 1;
  color: var(--COLOR_BRAND);
}
.source-column{
  li {
    .input{
      width: 100%;
    }
  }
}

</style>
